import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 业务设置定义
 */
class Type extends UltMeta {
    INSTALLATION_AND_PROMOTION_COMMISSION_SETTING = new Meta(1, "安装推广佣金设置");
}

export const TYPE = new Type();
